import type { BrowserOptions, EdgeOptions, NodeOptions } from '@sentry/nextjs';

declare global {
    interface Window {
        // merge in ContentSquare-to-Sentry integration types in global Window type
        CS_CONF: {
            integrations_handler: {
                sentry?: (event: unknown) => void;
            };
        };
        _uxa: unknown[];
    }
}

const SharedSentryOptions: BrowserOptions | NodeOptions | EdgeOptions = {
    sampleRate: Number(process.env.NEXT_PUBLIC_SENTRY_SAMPLE_RATE) || 0.1,
    beforeBreadcrumb(breadcrumb) {
        const maxSize = 5000; // 5000 characters limit
        if (breadcrumb?.message && breadcrumb.message?.length > maxSize) {
            breadcrumb.message = breadcrumb.message.slice(0, maxSize);
            breadcrumb.message += '\n [... Truncated to 5000 characters]';
        }
        return breadcrumb;
    },
    beforeSend(event) {
        /*
         * Name: Sentry / Contentsquare Integration
         * Version: 1.0.0
         */
        (function () {
            var eventPayload = event;

            function csCallback() {
                if (!disableCallback) {
                    disableCallback = true;

                    const sentryFunc = window.CS_CONF?.integrations_handler?.sentry;
                    if (sentryFunc) {
                        sentryFunc(eventPayload);
                    }
                }
            }
            var disableCallback = false;
            window._uxa = window._uxa || [];
            window._uxa.push(['afterPageView', csCallback]);
        })();

        const maxSize = 5000; // 5000 characters limit
        let message = event?.message || '';

        if (event?.exception?.values?.length) {
            event.exception.values.forEach(exception => {
                if (exception.value && exception.value.length > maxSize) {
                    let exceptionMessage = exception.value;
                    exceptionMessage = exceptionMessage.slice(0, maxSize);
                    exceptionMessage += '\n [... Truncated to 5000 characters]';
                    exception.value = exceptionMessage;
                }
            });
        }

        // Check if the message exceeds max size
        if (message.length > maxSize) {
            message = message.slice(0, maxSize);
            message += '\n [... Truncated to 5000 characters]';
            event.message = message;
        }

        // Returning modified event
        return event;
    },
    // Propagate Sentry trace headers to API calls
    // This enables distributed tracing between frontend and backend in Sentry
    tracePropagationTargets: [
        /^https:\/\/.*\.petsmart\.com\/api\//, // All petsmart.com API routes
        'localhost', // Local development
        /^\/api\//, // Relative URLs (same-origin)
    ],
};

export default SharedSentryOptions;
